import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { AbstractDtoService } from '@pct-ng/core/dto';
import type { BasePaginationDTO } from '@pct-sdk/core';

@Pipe({
  name: 'removeSelectedItems',
})
export class RemoveSelectedItemsPipe<
  SERVICE,
  CREATE_UPDATE_DTO,
  GET_DTO,
  LIST_DTO,
  ID_KEY extends keyof GET_DTO,
  GET_ALL_PARAMETERS extends { ids?: number[] | undefined; searchText?: string | undefined } = any,
  PAGINATED_DTO extends BasePaginationDTO = any,
  ID_TYPE = GET_DTO[ID_KEY],
> implements PipeTransform {
  transform(
    items: GET_DTO[],
    selectedItems: GET_DTO[],
    service: AbstractDtoService<
      SERVICE,
      CREATE_UPDATE_DTO,
      GET_DTO,
      LIST_DTO,
      ID_KEY,
      GET_ALL_PARAMETERS,
      PAGINATED_DTO,
      ID_TYPE
    >,
  ): GET_DTO[] {
    if (items.length === 0 || selectedItems.length === 0) {
      return items;
    }

    const selectedIds = selectedItems.map(item => service.getDtoId(item));
    return items.filter(item => !selectedIds.includes(service.getDtoId(item)));
  }
}
